import { __rest } from "tslib";
import { reportClientEvent as reportEvent } from '@lusha/bi-client-sdk';
const reportClientEvent = (_a) => {
    var { platform = 'plugin', subPlatform = 'linkedin', pageUrl } = _a, metadata = __rest(_a, ["platform", "subPlatform", "pageUrl"]);
    reportEvent({
        teamName: 'plugin',
        isLoggedIn: true,
        metadata: Object.assign(Object.assign({ platform,
            subPlatform,
            pageUrl }, metadata), { eventAdditionalInfo: Object.assign({}, (metadata.eventAdditionalInfo || {})) }),
    });
};
export default reportClientEvent;
